/**
 * Collapses id segments out of a route path so page views group by route rather
 * than by record.
 *
 *   /company/exhibitor/48213 -> /company/exhibitor/{id}
 *   /person/f4c1.../edit     -> /person/{id}/edit
 *
 * Without this, `/company/48213` and `/company/48214` are separate pageViews.name
 * values and the metric is unusable across company/:id, person/:id, group/:id,
 * events/:id and Registration/:id. This is also why enableAutoRouteTracking is off
 * -- it names page views by raw URL.
 */
const GUID =
  /^[0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12}$/i;

const isIdSegment = (segment) => /^\d+$/.test(segment) || GUID.test(segment);

export default function normalizePath(pathname) {
  if (typeof pathname !== 'string' || pathname === '') return '/';

  // Drop any query string or fragment: search routes carry user search terms and
  // detail routes carry record ids, neither of which belong in telemetry.
  const path = pathname.split(/[?#]/)[0];

  const normalized = path
    .split('/')
    .map((segment) => (isIdSegment(segment) ? '{id}' : segment))
    .join('/');

  // Preserve a single leading slash, drop a trailing one so `/search` and
  // `/search/` are the same page.
  if (normalized.length > 1 && normalized.endsWith('/')) {
    return normalized.slice(0, -1);
  }
  return normalized === '' ? '/' : normalized;
}
